import enUS from "./en-US.json";
import koKR from "./ko-KR.json";
import zhCN from "./zh-CN.json";
import { getLocaleOptions, getLocaleLabel, getLocale, setLocale, StandardLocale, PlatformType, LocaleOption } from "../gs-utils/core/storage/LocaleManager"

export { getLocale, setLocale, getLocaleLabel, getLocaleOptions, PlatformType } 
export type { LocaleOption }

export const initI18n = () => {
  // locale的存储必须和主应用保持一致
  let locale = getLocale();
  setLocale(locale);
  // 语言包放本地
  const localeMap: any = {
    [StandardLocale.ZH_CN]: zhCN,
    [StandardLocale.EN_US]: enUS,
    [StandardLocale.KO_KR]: koKR
  };
  (window as any).micLocale = localeMap[locale] || enUS;
};

export const i18n = (key: string, parameter?: any) => {
  try {
    const micLocale = (window as any)?.micLocale;
    let value = micLocale[key];
    if (!value) {
      return key;
    }
    if (typeof parameter == "string" || typeof parameter == "number") {
      value = value.replace(/%s/g, parameter);
    } else if (typeof parameter == "object") {
      for (let k in parameter) {
        if (
          typeof parameter[k] == "string" ||
          typeof parameter[k] == "number"
        ) {
          value = value.replace(new RegExp(`{{${k}}}`, "g"), parameter[k]);
        }
      }
    }
    return value;
  } catch (err) {
    return key;
  }
};
